module.exports = __webpack_public_path__ + "static/favonius-greatsword-5f166164216d4a21c8173b3f8795eadf.png";